import { storage } from "./firebaseConfig"; // Import the initialized storage instance
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage"; // Import Firebase Storage functions

// Define the async function to upload a file
// onProgress: optional callback (progress: number 0-100) => void
export const uploadFile = async (file, onProgress) => {
  if (!file) throw new Error("No file provided");

  // Create a unique filename with timestamp to prevent conflicts
  const timestamp = Date.now();
  const sanitizedName = file.name.replace(/[^a-zA-Z0-9.-]/g, '_');
  const uniqueFileName = `${timestamp}_${sanitizedName}`;

  // Create a reference to the file in Firebase Storage
  const storageRef = ref(storage, `uploads/${uniqueFileName}`);

  // Return a promise that resolves with the file's download URL
  return new Promise((resolve, reject) => {
    const uploadTask = uploadBytesResumable(storageRef, file);

    // Monitor the upload progress
    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log(`Upload is ${progress}% done`);
        if (typeof onProgress === "function") {
          onProgress(Math.round(progress));
        }
      },
      (error) => {
        // Handle errors during upload
        console.error("Upload error:", error);
        if (typeof onProgress === "function") {
          onProgress(-1); // Signal error
        }
        reject(error);
      },
      async () => {
        // Get the download URL once the upload is complete
        try {
          const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
          resolve(downloadURL); // Resolve with the download URL
        } catch (error) {
          reject(error); // Reject if there's an error getting the URL
        }
      }
    );
  });
};